import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectSubdomain(state: TApplicationState): string {
  return state.page.subdomain;
}
